import { render, staticRenderFns } from "./RowYet.vue?vue&type=template&id=0cb84ba8&scoped=true"
import script from "./RowYet.vue?vue&type=script&lang=js"
export * from "./RowYet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb84ba8",
  null
  
)

export default component.exports